import * as React from 'react';
import {useStyletron} from "baseui";
import {Select, SIZE} from "baseui/select";

export function CurrencySelector({
    currency,
    currencies,
    existingBilling,
    onChange,
    variant = 'desktop' // 'desktop' or 'mobile'
}) {
    const [css] = useStyletron();
    
    const selectProps = {
        disabled: existingBilling,
        size: SIZE.mini,
        options: currencies,
        backspaceRemoves: false,
        clearable: false,
        deleteRemoves: false,
        escapeClearsValue: false,
        required: true,
        searchable: false,
        value: [{key: currency}],
        labelKey: "value",
        valueKey: "key",
        onChange: onChange,
        overrides: {
            Root: {
                style: {
                    minWidth: '80px'
                }
            }
        }
    };

    const isDesktop = variant === 'desktop';
    
    if (isDesktop) {
        return (
            <div className={css({
                position: 'absolute',
                top: 0,
                right: 0,
                display: 'none',
                '@media (min-width: 1316px)': {
                    display: 'flex'
                }
            })}>
                <div className="flex items-center gap-2 bg-white rounded-lg shadow-sm border px-4 py-3">
                    <span className="text-[#656565] text-sm font-medium">Prices in</span>
                    <Select {...selectProps} />
                </div>
                {existingBilling && (
                    <div className={css({
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        marginTop: '8px',
                        textAlign: 'right',
                        color: '#656565',
                        fontSize: '12px',
                        maxWidth: '192px'
                    })}>
                        <a href="/#/app/settings/billing" className="text-action-blue hover:text-action-blue-dark underline">Change billing currency</a>
                    </div>
                )}
            </div>
        );
    }
    
    // Mobile variant
    return (
        <>
            <div className={css({
                display: 'flex',
                justifyContent: 'center',
                marginTop: '12px',
                '@media (min-width: 1316px)': {
                    display: 'none'
                }
            })}>
                <div className="flex items-center gap-2 bg-white rounded-lg shadow-sm border px-4 py-3">
                    <span className="text-[#656565] text-sm font-medium">Prices in</span>
                    <Select {...selectProps} />
                </div>
            </div>
            {existingBilling && (
                <div className={css({
                    display: 'block',
                    textAlign: 'center',
                    color: '#656565',
                    fontSize: '12px',
                    marginTop: '8px',
                    '@media (min-width: 1316px)': {
                        display: 'none'
                    }
                })}>
                    <a href="/#/app/settings/billing" className="text-action-blue hover:text-action-blue-dark underline">Change billing currency</a>
                </div>
            )}
        </>
    );
}
